module.exports = __webpack_public_path__ + "static/media/cassandra_serious.c692dc44.png";